import { IChangePasswordPayload, useChangePasswordQuery } from 'modules/shared/queries';
import React from 'react';
import { ChangePassword } from '../component/parts/user-details/change-password';

export function ChangePasswordContainer() {
    const { mutateAsync } = useChangePasswordQuery();
    const changePasswordHandler = React.useCallback((formData: IChangePasswordPayload) => mutateAsync({
        oldPassword: formData.oldPassword,
        newPassword: formData.newPassword
    }), [mutateAsync]);

    return (
        <ChangePassword changePasswordHandler={changePasswordHandler} />
    );
}
